var $ = require('jquery');

// Initial window dimensions
var windowHeight = window.innerHeight || document.documentElement.clientHeight;
var windowWidth = window.innerWidth || document.documentElement.clientWidth;

// Function to update window dimensions
function updateWindowDimensions() {
    windowHeight = window.innerHeight || document.documentElement.clientHeight;
    windowWidth = window.innerWidth || document.documentElement.clientWidth;
}

function logElementAndAncestorsWidth(element) {
    // Start from the current element and traverse up to the main body page element
    $(element).parentsUntil('body').addBack().each(function() {
        // Log the element and its width
        // console.log(this, 'Width:', $(this).width());
    });
}

// Function to check if an element is at least partially in the viewport, accounting for page scrolling
function isPartiallyInViewport(element) {
    var rect = element.getBoundingClientRect();
    // logElementAndAncestorsWidth(element);
    // console.log('element', element);
    // console.log('rect', rect);
    // console.log('windowHeight', windowHeight);
    // console.log('windowWidth', windowWidth);

    // Check if any part of the element is visible, accounting for scrolling
    var vertInView = (rect.top < windowHeight) && ((rect.top + rect.height) > 0);
    var horInView = (rect.left < windowWidth) && ((rect.left + rect.width) > 0);

    // console.log('vertInView', vertInView);
    // console.log('horInView', horInView);

    return (vertInView && horInView);
}

// Update window dimensions when the window is resized
window.addEventListener('resize', updateWindowDimensions);

module.exports = isPartiallyInViewport;
